import {
    getCodeOdooLoading,
    getCodeOdooReject,
    getCodeOdooRequest,
    getCodeOdooSuccess
} from "../../actions/provider/getAllOdoo";

export const getCodeOdoo = (formData) => async (dispatch, getState) => {
    dispatch(getCodeOdooLoading());
    try {
        const { data } = await getCodeOdooRequest(formData, getState);
        dispatch(getCodeOdooSuccess(data))
    } catch (error) {
        dispatch(getCodeOdooReject(error))
    }
    return Promise.resolve();
};